"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.borderImageSlicePredicate = exports.textDecorationLinePredicate = exports.gridAutoFlowPredicate = exports.gridTemplateAreasStringPredicate = exports.autoTrackListPredicate = exports.getTrackListRowsText = exports.getTrackListAreasText = exports.trackListWithStringsPredicate = exports.parseTrackListWithStrings = exports.explicitTrackListPredicate = exports.trackListPredicate = exports.trackSizePredicate = exports.lineNamesPredicate = exports.gridLinePredicate = exports.fontFamilyStringPredicate = exports.fontStylePredicate = exports.autoKeywordPredicate = exports.anglePredicate = exports.calcPredicate = exports.lengthPercentagePredicate = exports.percentagePredicate = exports.lengthPredicate = exports.numberPredicate = void 0;
var tslib_1 = require("tslib");
var tokenizers_1 = require("../tokenizers");
var data_types_consts_1 = require("./data-types-consts");
var data_types_utils_1 = require("./data-types-utils");
// <number>
exports.numberPredicate = (0, data_types_utils_1.dimensionPredicate)();
// <length>
var lengthPredicate = function (ast) {
    return (0, data_types_utils_1.dimensionPredicate)({ units: data_types_consts_1.LENGTH_UNITS_MAP })(ast) || (0, data_types_utils_1.functionPredicate)(data_types_consts_1.SPX_FORMATTER)(ast);
};
exports.lengthPredicate = lengthPredicate;
// <percentage>
exports.percentagePredicate = (0, data_types_utils_1.dimensionPredicate)({ units: data_types_consts_1.PERCENTAGE_UNIT });
// <length-percentage>
exports.lengthPercentagePredicate = (0, data_types_utils_1.dimensionPredicate)({ units: data_types_consts_1.LENGTH_PERCENTAGE_UNITS });
// <calc()>
exports.calcPredicate = (0, data_types_utils_1.functionPredicate)(data_types_consts_1.CALC_FUNCTION);
// <angle>
exports.anglePredicate = (0, data_types_utils_1.dimensionPredicate)({ units: data_types_consts_1.ANGLE_UNITS });
// <flex>
var flexPredicate = (0, data_types_utils_1.dimensionPredicate)({ units: data_types_consts_1.FLEX_UNIT, min: data_types_consts_1.FLEX_NUMBER_RANGE_MIN });
// 'auto'
exports.autoKeywordPredicate = (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.AUTO_KEYWORD);
// <font-style>
// syntax: normal | italic | oblique <angle>?
var fontStylePredicate = function (ast, index, items) {
    if (index === undefined || !items) {
        return false;
    }
    var obliquePredicate = (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.FONT_STYLE_OBLIQUE_KEYWORD);
    var matchAmount = 0;
    if (obliquePredicate(ast)) {
        matchAmount++;
        var next = items[index + 1];
        if (next && (0, exports.anglePredicate)(next.value)) {
            matchAmount++;
        }
    }
    return matchAmount;
};
exports.fontStylePredicate = fontStylePredicate;
// <font-family>
// syntax: <generic-family> | <string>
exports.fontFamilyStringPredicate = (0, data_types_utils_1.typePredicate)(['text', 'string', ',']);
// <grid-line>
// syntax: <custom-ident> | [ <integer> && <custom-ident>? ] | [ span && [ <integer> || <custom-ident> ] ]
var gridLinePredicate = function (ast, index, items) {
    var startIndex = index !== null && index !== void 0 ? index : 0;
    var astItems = items !== null && items !== void 0 ? items : [{ value: ast }];
    var nonZeroIntegerPredicate = (0, data_types_utils_1.dimensionPredicate)({ nonZero: true, integer: true });
    var gridLineCustomIdentPredicate = (0, data_types_utils_1.customIdentPredicate)(data_types_consts_1.GRID_LINE_SPAN_KEYWORD);
    var spanPredicate = (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.GRID_LINE_SPAN_KEYWORD);
    var hasSpan = false;
    var hasCustomIdent = false;
    var hasInteger = false;
    var item;
    var i = startIndex;
    while ((item = astItems[i++])) {
        if (gridLineCustomIdentPredicate(item.value)) {
            if (hasCustomIdent) {
                break;
            }
            hasCustomIdent = true;
        }
        else if (nonZeroIntegerPredicate(item.value)) {
            if (hasInteger) {
                break;
            }
            hasInteger = true;
        }
        else if (spanPredicate(item.value)) {
            if (hasSpan) {
                break;
            }
            hasSpan = true;
        }
        else {
            break;
        }
    }
    return !hasSpan || hasCustomIdent || hasInteger ? +hasSpan + +hasCustomIdent + +hasInteger : false;
};
exports.gridLinePredicate = gridLinePredicate;
// <track-breadth>
// syntax: <length-percentage> | <flex> | min-content | max-content | auto
var trackBreadthPredicate = (0, data_types_utils_1.predicateUnion)([
    exports.lengthPercentagePredicate,
    flexPredicate,
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.BREADTH_KEYWORDS),
]);
var INVALID_LINE_NAMES_MATCH = { names: [], match: false };
var parseLineNames = function (ast, index, items) {
    var startIndex = index !== null && index !== void 0 ? index : 0;
    var astItems = items !== null && items !== void 0 ? items : [{ value: ast }];
    var lineNamesCustomIdentPredicate = (0, data_types_utils_1.customIdentPredicate)(data_types_consts_1.LINE_NAMES_EXCLUDE_KEYWORDS);
    var names = [];
    var matchAmount = 0;
    var hasClosingBracket = false;
    for (var i = startIndex; i < astItems.length; i++) {
        var value = astItems[i].value;
        var currText = value.text;
        var isStart = i === startIndex;
        var hasOpeningBracket = currText.startsWith('[');
        hasClosingBracket = currText.endsWith(']');
        if (value.type !== 'text' || (isStart && !hasOpeningBracket) || (!isStart && hasOpeningBracket)) {
            return tslib_1.__assign({}, INVALID_LINE_NAMES_MATCH);
        }
        currText = currText.slice(hasOpeningBracket ? 1 : 0, currText.length - (hasClosingBracket ? 1 : 0));
        if (currText !== '' &&
            (currText.includes('[') ||
                currText.includes(']') ||
                !lineNamesCustomIdentPredicate((0, tokenizers_1.valueTextNode)(currText)))) {
            return tslib_1.__assign({}, INVALID_LINE_NAMES_MATCH);
        }
        if (currText !== '') {
            names.push(currText);
        }
        matchAmount++;
        if (hasClosingBracket) {
            break;
        }
    }
    return hasClosingBracket ? { names: names, match: matchAmount } : tslib_1.__assign({}, INVALID_LINE_NAMES_MATCH);
};
var lineNamesPredicate = function (ast, index, items) { return parseLineNames(ast, index, items).match; };
exports.lineNamesPredicate = lineNamesPredicate;
// <track-size>
// syntax: <track-breadth> | minmax( <inflexible-breadth> , <track-breadth> ) | fit-content( [ <length> | <percentage> ] )
exports.trackSizePredicate = (0, data_types_utils_1.predicateUnion)([trackBreadthPredicate, (0, data_types_utils_1.functionPredicate)(data_types_consts_1.TRACK_SIZE_FUNCTIONS)]);
// <track-repeat> / <fixed-repeat> / <auto-repeat>
var repeatPredicate = (0, data_types_utils_1.functionPredicate)(data_types_consts_1.REPEAT_FUNCTION);
// <auto-repeat>
// syntax: repeat( [ auto-fill | auto-fit ] , [ <line-names>? <fixed-size> ]+ <line-names>? )
var autoRepeatPredicate = function (ast) {
    if (repeatPredicate(ast)) {
        var firstArgPredicate = (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.AUTO_REPEAT_FIRST_ARGUMENT_KEYWORDS);
        var firstArg = ast.args[0];
        if (firstArg) {
            return firstArgPredicate(firstArg);
        }
    }
    return false;
};
// <fixed-size>
// syntax: <fixed-breadth> | minmax( <fixed-breadth> , <track-breadth> ) | minmax( <inflexible-breadth> , <fixed-breadth> )
var fixedSizePredicate = (0, data_types_utils_1.predicateUnion)([exports.lengthPercentagePredicate, (0, data_types_utils_1.functionPredicate)(data_types_consts_1.MINMAX_FUNCTION)]);
var singleTrackPredicate = function (trackPredicates, asterisk) {
    if (asterisk === void 0) { asterisk = false; }
    return function (ast, index, items) {
        var startIndex = index !== null && index !== void 0 ? index : 0;
        var astItems = items !== null && items !== void 0 ? items : [{ value: ast }];
        var item;
        var i = startIndex;
        var hasPrevNames = false;
        var isValid = asterisk;
        var matchAmount = 0;
        while ((item = astItems[i])) {
            var lineNamesMatch = parseLineNames(item.value, i, astItems).match;
            if (lineNamesMatch) {
                if (hasPrevNames) {
                    break;
                }
                i += Number(lineNamesMatch);
                matchAmount += Number(lineNamesMatch);
                hasPrevNames = true;
            }
            else if (trackPredicates.some(function (predicate) { return predicate(item.value); })) {
                isValid = true;
                hasPrevNames = false;
                i++;
                matchAmount++;
            }
            else {
                break;
            }
        }
        return isValid ? matchAmount : false;
    };
};
// <track-list>
// syntax: [ <line-names>? [ <track-size> | <track-repeat> ] ]+ <line-names>?
exports.trackListPredicate = singleTrackPredicate([exports.trackSizePredicate, repeatPredicate]);
// <explicit-track-list>
// syntax: [ <line-names>? <track-size> ]+ <line-names>?
exports.explicitTrackListPredicate = singleTrackPredicate([exports.trackSizePredicate]);
var EMPTY_TRACK = { string: '', trackSize: data_types_consts_1.INITIAL_TRACK_SIZE };
var INVALID_TRACK_MATCH = { tracks: [], match: false };
var parseTrackListWithStrings = function (ast, index, items) {
    var startIndex = index !== null && index !== void 0 ? index : 0;
    var astItems = items !== null && items !== void 0 ? items : [{ value: ast }];
    var tracks = [tslib_1.__assign({}, EMPTY_TRACK)];
    var item;
    var i = startIndex;
    var isValid = false;
    var matchAmount = 0;
    while ((item = astItems[i])) {
        if (item.value.type === 'string') {
            tracks[tracks.length - 1].string = item.value.text;
            isValid = true;
        }
        else {
            var hasString = tracks[tracks.length - 1].string === '';
            var lineNames = parseLineNames(item.value, i, astItems);
            if (lineNames.match) {
                if (hasString) {
                    if (tracks[tracks.length - 1].lineNamesBefore) {
                        return tslib_1.__assign({}, INVALID_TRACK_MATCH);
                    }
                    tracks[tracks.length - 1].lineNamesBefore = lineNames.names;
                    isValid = false;
                }
                else {
                    tracks[tracks.length - 1].lineNamesAfter = lineNames.names;
                    tracks.push(tslib_1.__assign({}, EMPTY_TRACK));
                }
                i += Number(lineNames.match) - 1;
                matchAmount += Number(lineNames.match) - 1;
            }
            else if ((0, exports.trackSizePredicate)(item.value, i, astItems)) {
                if (hasString) {
                    return tslib_1.__assign({}, INVALID_TRACK_MATCH);
                }
                tracks[tracks.length - 1].trackSize = item.value.text;
            }
            else {
                break;
            }
        }
        i++;
        matchAmount++;
    }
    if (isValid && tracks[tracks.length - 1].string === '') {
        tracks.pop();
    }
    return isValid ? { tracks: tracks, match: matchAmount } : tslib_1.__assign({}, INVALID_TRACK_MATCH);
};
exports.parseTrackListWithStrings = parseTrackListWithStrings;
var trackListWithStringsPredicate = function (ast, index, items) {
    return (0, exports.parseTrackListWithStrings)(ast, index, items).match;
};
exports.trackListWithStringsPredicate = trackListWithStringsPredicate;
var getTrackListAreasText = function (_a) {
    var tracks = _a.tracks;
    return tracks.map(function (_a) {
        var string = _a.string;
        return string;
    }).join(' ');
};
exports.getTrackListAreasText = getTrackListAreasText;
var getTrackListRowsText = function (_a) {
    var tracks = _a.tracks;
    return tracks
        .map(function (_a, index) {
        var trackSize = _a.trackSize, lineNamesBefore = _a.lineNamesBefore, lineNamesAfter = _a.lineNamesAfter;
        var beforeString = index === 0 ? (lineNamesBefore ? "[".concat(lineNamesBefore.join(' '), "] ") : '') : '';
        var afterList = lineNamesAfter !== null && lineNamesAfter !== void 0 ? lineNamesAfter : [];
        var nextTrack = tracks[index + 1];
        // Splicing in the named lines defined before/after each size
        if (nextTrack && nextTrack.lineNamesBefore) {
            afterList = afterList.concat(nextTrack.lineNamesBefore);
        }
        var afterString = afterList.length > 0 ? " [".concat(afterList.join(' '), "]") : '';
        return "".concat(beforeString).concat(trackSize).concat(afterString);
    })
        .join(' ');
};
exports.getTrackListRowsText = getTrackListRowsText;
// <auto-track-list>
// syntax: [ <line-names>? [ <fixed-size> | <fixed-repeat> ] ]* <line-names>? <auto-repeat> [ <line-names>? [ <fixed-size> | <fixed-repeat> ] ]* <line-names>?
var autoTrackListPredicate = function (ast, index, items) {
    var startIndex = index !== null && index !== void 0 ? index : 0;
    var astItems = items !== null && items !== void 0 ? items : [{ value: ast }];
    var item;
    var i = startIndex;
    var autoRepeatIndex = -1;
    while ((item = astItems[i])) {
        if (autoRepeatPredicate(item.value)) {
            autoRepeatIndex = i;
            break;
        }
        i++;
    }
    if (autoRepeatIndex === -1) {
        return false;
    }
    var prefixSuffixTrackListPredicate = singleTrackPredicate([fixedSizePredicate, repeatPredicate], true);
    var matchAmount = 1;
    if (autoRepeatIndex > startIndex) {
        var prefixMatch = prefixSuffixTrackListPredicate(astItems[startIndex].value, 0, astItems.slice(startIndex, autoRepeatIndex));
        if (!prefixMatch || Number(prefixMatch) !== autoRepeatIndex - startIndex) {
            return false;
        }
        matchAmount += autoRepeatIndex - startIndex;
    }
    if (astItems[autoRepeatIndex + 1]) {
        matchAmount += Number(prefixSuffixTrackListPredicate(astItems[autoRepeatIndex + 1].value, 0, astItems.slice(autoRepeatIndex + 1)));
    }
    return matchAmount;
};
exports.autoTrackListPredicate = autoTrackListPredicate;
// <grid-template-areas>
// syntax: none | <string>+
exports.gridTemplateAreasStringPredicate = (0, data_types_utils_1.typePredicate)(['string']);
// <grid-auto-flow>
// syntax: auto-flow && dense?
var gridAutoFlowPredicate = function (ast, index, items) {
    var startIndex = index !== null && index !== void 0 ? index : 0;
    var astItems = items !== null && items !== void 0 ? items : [{ value: ast }];
    var autoFlowPredicate = (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.GRID_AUTO_FLOW_KEYWORD);
    var densePredicate = (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.GRID_AUTO_FLOW_DENSE_KEYWORD);
    var hasAutoFlow = false;
    var hasDense = false;
    var item;
    var i = startIndex;
    while ((item = astItems[i++])) {
        if (autoFlowPredicate(item.value)) {
            if (hasAutoFlow) {
                break;
            }
            hasAutoFlow = true;
        }
        else if (densePredicate(item.value)) {
            if (hasDense) {
                break;
            }
            hasDense = true;
        }
        else {
            break;
        }
    }
    return hasAutoFlow ? +hasAutoFlow + +hasDense : false;
};
exports.gridAutoFlowPredicate = gridAutoFlowPredicate;
// <text-decoration-line>
// syntax: none | [ underline || overline || line-through ]
var textDecorationLinePredicate = function (ast, index, items) {
    var startIndex = index !== null && index !== void 0 ? index : 0;
    var astItems = items !== null && items !== void 0 ? items : [{ value: ast }];
    var currKeywords = new Map(data_types_consts_1.TEXT_DECORATION_LINE_KEYWORDS);
    var currPredicate = (0, data_types_utils_1.unorderedListPredicate)(currKeywords);
    var item;
    var i = startIndex;
    var matchAmount = 0;
    while (currKeywords.size > 0 && (item = astItems[i++])) {
        if (currPredicate(item.value, i - 1, astItems)) {
            matchAmount++;
            currKeywords.delete(item.value.text);
            currPredicate = (0, data_types_utils_1.unorderedListPredicate)(currKeywords);
        }
        else {
            break;
        }
    }
    return matchAmount;
};
exports.textDecorationLinePredicate = textDecorationLinePredicate;
// <border-image-slice>
// syntax: <number-percentage>{1,4} && fill?
var borderImageSlicePredicate = function (ast, index, items) {
    var e_1, _a;
    var startIndex = index !== null && index !== void 0 ? index : 0;
    var astItems = items !== null && items !== void 0 ? items : [{ value: ast }];
    var numberPercentagePredicates = [exports.numberPredicate, exports.percentagePredicate];
    var fillPredicate = (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.BORDER_IMAGE_SLICE_FILL_KEYWORD);
    var item;
    var i = startIndex;
    var matchAmount = 0;
    var matchedFill = false;
    var match;
    while ((item = astItems[i++])) {
        match = undefined;
        var fillMatch = fillPredicate(item.value, i - 1, astItems);
        if (fillMatch) {
            if (matchedFill) {
                break;
            }
            match = fillMatch;
            matchedFill = true;
        }
        else {
            try {
                for (var numberPercentagePredicates_1 = (e_1 = void 0, tslib_1.__values(numberPercentagePredicates)), numberPercentagePredicates_1_1 = numberPercentagePredicates_1.next(); !numberPercentagePredicates_1_1.done; numberPercentagePredicates_1_1 = numberPercentagePredicates_1.next()) {
                    var predicate = numberPercentagePredicates_1_1.value;
                    var numberPercentageMatch = predicate(item.value, i - 1, astItems);
                    if (numberPercentageMatch) {
                        match = numberPercentageMatch;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (numberPercentagePredicates_1_1 && !numberPercentagePredicates_1_1.done && (_a = numberPercentagePredicates_1.return)) _a.call(numberPercentagePredicates_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (!match || ++matchAmount === (matchedFill ? 5 : 4)) {
            break;
        }
    }
    if (matchAmount === 4 && match && (item = astItems[i])) {
        return fillPredicate(item.value, i - 1, astItems) ? 5 : 4;
    }
    return matchAmount >= 1 ? (!matchedFill || matchAmount > 1 ? matchAmount : false) : false;
};
exports.borderImageSlicePredicate = borderImageSlicePredicate;
//# sourceMappingURL=data-types-predicates.js.map